import {State, Getter, Action, Mutation, namespace} from 'vuex-class'
import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
// @ts-ignore
import VueNeditorWrap from 'vue-neditor-wrap'

@Component({name: 'VsonNEditor', components: {VueNeditorWrap}})
export default class VsonNEditor extends Vue {
  @Prop() private name?: string;
  @State('formFields', {namespace: 'common'}) formFields: any
  //@Action('getBanners', {namespace: 'mall'}) getBanners: any
  // 初始化数据
  timestamp = new Date().getTime()
  nEditorConfig = {
    // 如果需要上传功能,找后端小伙伴要服务器接口地址
    serverUrl: 'https://up.qiniup.com',
    // 你的UEditor资源存放的路径,相对于打包后的index.html
    UEDITOR_HOME_URL: process.env.NODE_ENV === 'production' ? '/vson_crm/NEditor/':'/NEditor/',
    // 编辑器不自动被内容撑高
    // autoHeightEnabled: true,
    // 初始容器高度
    initialFrameHeight: 500,
    // 初始容器宽度
    initialFrameWidth: '100%',
    // 关闭自动保存
    enableAutoSave: false,
    imageUrlPrefix: 'https://imgqiniu.vson.com.cn/',
    scrawlUrlPrefix: "https://imgqiniu.vson.com.cn/",
    videoUrlPrefix: "https://imgqiniu.vson.com.cn/",
    fileUrlPrefix: "https://imgqiniu.vson.com.cn/",
  }
  content = ''


  // 计算属性 computed
  get users() {
    return []
  }

  create() {

  }

  // 声明周期钩子
  mounted() {
    this.init()
  }

  init() {
    this.$notify.info({
      title: '富文本编辑器使用说明',
      duration: 10000,
      message: '点击编辑器最右上角的显示器图标可将编辑器全屏显示和还原，点击编辑器最左上角的"HTML"按钮即可插入从其他排版编辑器拷贝的html代码，'
    });
  }

  @Watch('watchValue')
  watchValue(val: any) {

  }

  // 方法
  onReady() {
  }

}
